import { render } from "./GamefamPortfolioMetrics.vue?vue&type=template&id=788498a8&scoped=true"
import script from "./GamefamPortfolioMetrics.vue?vue&type=script&lang=js"
export * from "./GamefamPortfolioMetrics.vue?vue&type=script&lang=js"

import "./GamefamPortfolioMetrics.vue?vue&type=style&index=0&id=788498a8&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788498a8"]])

export default __exports__